import apiRequest from "./axiosInstance";

/**
 * Fetches a list of journals
 * @returns {Promise<Object>} Response object from the API request
 */
export const fetchJournals = (data) => {
  const idQuery = data.id ? `id=${encodeURIComponent(data.id)}` : "";
  const countQuery = data.count
    ? `count=${encodeURIComponent(data.count)}`
    : "";
  const keyQuery = `key=${encodeURIComponent(data.key || "journalName")}`;
  const directionQuery = `direction=${encodeURIComponent(
    data.direction || "asc"
  )}`;
  const searchQuery = data.search
    ? `search=${encodeURIComponent(data.search)}`
    : "";
  const placeQuery = data.place ? `place=${data.place}` : "";

  const queryParams = [
    idQuery,
    placeQuery,
    countQuery,
    keyQuery,
    directionQuery,
    searchQuery,
  ]
    .filter(Boolean)
    .join("&");

  return apiRequest("get", `/journals?${queryParams}`);
};

export const fetchJournalOverview = (data) => {
  const idQuery = data.id ? `id=${encodeURIComponent(data.id)}` : "";
  const keyQuery = `key=${encodeURIComponent(data.key || "journalName")}`;
  const directionQuery = `direction=${encodeURIComponent(
    data.direction || "asc"
  )}`;
  const searchQuery = data.search
    ? `search=${encodeURIComponent(data.search)}`
    : "";

  const queryParams = [idQuery, keyQuery, directionQuery, searchQuery]
    .filter(Boolean)
    .join("&");

  return apiRequest("get", `/journals/journalOverview?${queryParams}`);
};

/**
 * Fetches a journal by its ID
 * @param {string|number} id - Journal ID
 * @returns {Promise<Object>} Response object from the API request
 */
export const fetchJournalById = (id) => apiRequest("get", `/journals/${id}`);

export const FetchPreferencesJournal = (id) =>
  apiRequest("get", `/journals/preferences/${id}`);

export const fetchPreferred = () => apiRequest("get", `/journals/preferences/`);

/**
 * Creates a new journal
 * @param {Object} journalData - Data for the new journal
 * @returns {Promise<Object>} Response object from the API request
 */
export const addJournal = (journalData) =>
  apiRequest("post", "/journals", journalData, {}, {}, true);

/**
 * Updates an existing journal
 * @param {string|number} id - Journal ID
 * @param {Object} journalData - Updated journal data
 * @returns {Promise<Object>} Response object from the API request
 */
export const updateJournal = (id, journalData) =>
  apiRequest("put", `/journals/${id}`, journalData);

/**
 * Deletes a journal by its ID
 * @param {string|number} id - Journal ID
 * @returns {Promise<Object>} Response object from the API request
 */
export const deleteJournal = (id) => apiRequest("delete", `/journals/${id}`);

/**
 * Journal API service module
 * @module
 */
